export interface LoaderConfig {
  fullScreen?: boolean;
  type?: 'spinner' | 'progress' | 'dots';
  text?: string;
  overlay?: boolean;
  customClass?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const DEFAULT_LOADER_CONFIG: LoaderConfig = {
  fullScreen: false,
  type: 'spinner',
  overlay: true,
  size: 'md'
};
